<div
  [ngClass]="{collapsed: collapsed}"
  class="booking-faq booking-card sidebar prose prose-sm relative overflow-hidden shadow-sm transition-all delay-500"
>
  <h3>Frågor vid bokning på Vården.se</h3>

  <h4>Hur gör jag för att boka en tid på Vården.se?</h4>
  <p>
    Vården.se är en digital bokningstjänst som underlättar för dig när du ska
    boka vård. Du väljer enkelt den tid som passar dig i kalendern. Sedan fyller
    du i dina uppgifter och klickar på BOKA. Behöver du hjälp med bokningen kan
    du skriva till oss i vår chatt, som är öppen alla vardagar mellan kl 8-17.
  </p>

  <h4>Kostar det något extra att boka vård via Vården.se?</h4>
  <p>
    Nej, det kostar inget extra att boka tid via Vården.se, jämfört med om du
    skulle boka direkt hos din vårdgivare. Om vårdgivaren är ansluten till
    regionen gäller de regionala patientavgifterna och frikort. Om vårdgivaren
    är helt privat behöver du betala hela kostnaden för ditt besök själv.
  </p>

  <h4>Är Vården.se en vårdgivare?</h4>
  <p>
    Nej, Vården.se är en jämförelse- och bokningssajt som underlättar för dig
    som patient när du ska söka vård. Vi som jobbar på Vården.se är inte
    utbildad vårdpersonal och kan inte hjälpa dig med specifika besvär, eller
    med att komma i kontakt med enskilda vårdgivare eller läkare.
  </p>

  <h4>Varför finns Vården.se?</h4>
  <p>
    Vården.se har som vision att samla all vård på ett ställe, så att du kan
    söka, jämföra och boka tid hos den vårdgivare som passar dig bäst. Hos oss
    kan du hitta regional, privat och försäkringsfinansierad vård på ett och
    samma ställe.
  </p>

  <h4>Finns alla vårdgivare med på Vården.se?</h4>
  <p>
    Ja, på Vården.se kan du hitta alla legitimerade vårdgivare i Sverige. Många
    av dem kan du boka tid hos online, medan andra tar emot bokningar via
    telefon eller mejl.
  </p>

  <div (click)="togglePanel()" *ngIf="collapsed" class="expand-btn">
    <app-ui-icon
      color="rgba(6, 113, 133, 1)"
      name="chevron_expand"
      size="md"
    ></app-ui-icon>
  </div>
  <div (click)="togglePanel()" *ngIf="!collapsed" class="collapse-btn">
    <app-ui-icon
      color="rgba(6, 113, 133, 1)"
      name="chevron_collapse"
      size="md"
    ></app-ui-icon>
  </div>
</div>
